import System from "~/store/modules/SystemModule";
import Hospital from "~/store/modules/HospitalStore";
import Appointment from "~/store/modules/AppointmentStore";
import AppointmentSteps from "~/store/modules/AppointmentStepsStore";
import Specialist from "~/store/modules/SpecialistStore";
import City from "~/store/modules/CityStore";
import Journal from "~/store/modules/JournalStore";
import Patient from "~/store/modules/PatientStore";
import Speciality from "~/store/modules/SpecialityStore";
import EgisError from "~/store/modules/EgisErrorStore";
import Popup from "~/store/modules/PopupStore";

class RootStore {
  systemStore!: System;
  cityStore!: City;
  patientStore!: Patient;
  hospitalStore!: Hospital;
  specialityStore!: Speciality;
  specialistStore!: Specialist;
  appointmentStepsStore!: AppointmentSteps;
  appointmentStore!: Appointment;
  journalStore!: Journal;
  popupStore!: Popup;
  egisErrorStore!: EgisError;

  constructor() {
    this.systemStore = new System(this);
    this.cityStore = new City(this);
    this.patientStore = new Patient(this);
    this.hospitalStore = new Hospital(this);
    this.specialityStore = new Speciality(this);
    this.specialistStore = new Specialist(this);
    this.appointmentStepsStore = new AppointmentSteps(this);
    this.appointmentStore = new Appointment(this);
    this.journalStore = new Journal(this);
    this.popupStore = new Popup(this);
    this.egisErrorStore = new EgisError(this);
  }

  resetAppointmentProcess() {
    this.patientStore = new Patient(this);
    this.hospitalStore = new Hospital(this);
    this.specialistStore = new Specialist(this);
    this.specialityStore = new Speciality(this);
    this.appointmentStore = new Appointment(this);
    this.appointmentStepsStore = new AppointmentSteps(this);
    this.journalStore = new Journal(this);

    this.egisErrorStore.resetNonBreakingErrorsToInitialState();
  }
}

export default RootStore;
